import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Job } from '../../jobs.models';

enum TabLabels {
  Variables = 'Variables',
  Outputs = 'Outputs',
  Errors = 'Errors',
  Tasks = 'Tasks',
}

@Component({
  selector: 'job-view',
  template: `
    <div class="job-view">
      <div class="job-view-body">
        <xp-loader *ngIf="!isLoaded"></xp-loader>
        <mat-tab-group
          animationDuration="0ms"
          dynamicHeight
          (selectedTabChange)="onTabChange($event)"
          [selectedIndex]="selectedTabIndex"
        >
          <mat-tab [label]="tabLabels.Variables"><job-variables [item]="item"></job-variables></mat-tab>
          <mat-tab *ngIf="areOutputsAvailable && !isWorkflow" [label]="tabLabels.Outputs"
            ><job-outputs [item]="item"></job-outputs
          ></mat-tab>
          <mat-tab *ngIf="isWorkflow" [label]="tabLabels.Tasks"
            ><job-tasks
              (childOpen)="childOpen.emit($event)"
              (loadMoreTasks)="loadMoreTasks.emit()"
              [childJobs]="childJobs"
              [isLoaded]="isLoaded"
              [item]="item"
            ></job-tasks
          ></mat-tab>
          <mat-tab *ngIf="areErrorsAvailable" [label]="tabLabels.Errors"
            ><job-errors [item]="item"></job-errors
          ></mat-tab>
        </mat-tab-group>
      </div>
      <div class="job-view-footer">
        <div class="job-list-item-job">
          <div class="job">{{ 'generic-list.jobs.id' | translate }}</div>
          <div class="package">{{ 'generic-list.jobs.package' | translate }}</div>
          <div class="cluster">{{ 'generic-list.jobs.cluster' | translate }}</div>
          <div class="runtime">{{ 'generic-list.jobs.runtime' | translate }}</div>
          <div class="status">{{ 'generic-list.jobs.status' | translate }}</div>
        </div>
        <job-list-item [item]="item" [hideDropDown]="true"></job-list-item>
      </div>
    </div>
  `,
})
export class JobViewComponent implements OnInit {
  @Input() item: Job;
  @Input() isLoaded: boolean;
  @Input() childJobs: Job[];
  @Output() childOpen = new EventEmitter<Job>();
  @Output() loadMoreTasks = new EventEmitter();

  tabLabels = TabLabels;
  selectedTabIndex = 1;

  constructor(@Inject('$rootScope') private $rootScope: any) {}

  get areOutputsAvailable(): boolean {
    return this.item.outputs && this.item.outputs.length > 0;
  }

  get areErrorsAvailable(): boolean {
    return this.item.status && (this.item.status === 'failed' || !!this.item.errors);
  }

  get isWorkflow(): boolean {
    return this.item.package.flow_type === 'workflow';
  }

  ngOnInit() {
    if (this.areOutputsAvailable) {
      if (this.$rootScope.stateIncludes('app.account.jobs.item.children')) {
        this.$rootScope.stateGo('app.account.jobs.item.children.outputs');
      } else {
        this.$rootScope.stateGo('app.account.jobs.item.outputs');
      }
    }

    if (this.areErrorsAvailable) {
      if (this.$rootScope.stateIncludes('app.account.jobs.item.children')) {
        this.$rootScope.stateGo('app.account.jobs.item.children.errors');
      } else {
        this.$rootScope.stateGo('app.account.jobs.item.errors');
      }
    }
  }

  onTabChange(event: MatTabChangeEvent): void {
    const tabName = event.tab.textLabel;

    if (tabName === TabLabels.Variables) {
      if (this.$rootScope.stateIncludes('app.account.jobs.item.children')) {
        this.$rootScope.stateGo('app.account.jobs.item.children.variables');
      } else {
        this.$rootScope.stateGo('app.account.jobs.item.variables');
      }
    }

    if (tabName === TabLabels.Outputs) {
      if (this.$rootScope.stateIncludes('app.account.jobs.item.children')) {
        this.$rootScope.stateGo('app.account.jobs.item.children.outputs');
      } else {
        this.$rootScope.stateGo('app.account.jobs.item.outputs');
      }
    }

    if (tabName === TabLabels.Errors) {
      if (this.$rootScope.stateIncludes('app.account.jobs.item.children')) {
        this.$rootScope.stateGo('app.account.jobs.item.children.errors');
      } else {
        this.$rootScope.stateGo('app.account.jobs.item.errors');
      }
    }
  }
}
